import { NgModule } from '@angular/core';
import { PreloadAllModules, provideRouter, RouterModule, Routes, withComponentInputBinding, withPreloading } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoginPage } from './layouts/login/login.page';
import { FormsModule } from '@angular/forms';

const routes: Routes = [
  {
    path: 'auth',
    component: LoginPage,
  },
  {
    path: 'tabs',
    loadChildren: () => import('./layouts/tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: '',
    redirectTo: 'tabs', pathMatch: 'full',
  },
];

@NgModule({
  declarations: [LoginPage],
  providers: [
    provideRouter(routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding()
    ),
  ],
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    TranslateModule.forChild(),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
